
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import { ShortCommandPostRequest } from './types';
import { ShortCommandPostResponse } from '../entities/short-commands-v1/short-command-post-response';
import { axiosInstance } from "../axios-instance";

class ShortCommand {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  queueShortCommandForAssetOrDevice(
    input: ShortCommandPostRequest,
  ): Promise<AxiosResponse<ShortCommandPostResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<ShortCommandPostResponse>(`${this.baseUrl}/queueCommands`, input, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }
}

export default ShortCommand;
